import storeHelper from '@/store/helper'
import axios from 'axios'
import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class UsersService extends BaseService {
  static get entity () {
    return 'users'
  }

  static async getCurrent (token = null, systemConfig = null) {
    try {
      let response = null
      if (token && systemConfig) {
        response = await axios.post(storeHelper.getUrl('cnps.sur.get-current', systemConfig), {}, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        })
      } else response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.get-current'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async fillPermissionByUser (params = {}) {
    
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.user-get-permissions'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changeToNotYet (agentID) {
    try {
      const response = await axios.post(storeHelper.getUrl('cnps.agent.update-identity-status'), {
        "agentId": agentID,
        "status": "NOT_YET"
      })
      const item = JSON.parse(localStorage.getItem('userData')) ?? {}
      item.status = 'NOT_YET'
      localStorage.setItem('userData', JSON.stringify(item))
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  static async getProfile (agentId) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.detail-agent'), { agentId })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  static async updateProfile (params = {}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.update-agent-for-web'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  
  static async getVerifyAccount (agentId) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.detail-accuracy-agent-v2'), { agentId })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  static async verifyAccount (params = {}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.add-accuracy-agent-v2'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  static async updateVerifyAccount (params = {}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.update-accuracy-agent-v2'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  static async addBankAccount (params = {}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.add-bank-account'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  static async setToMainBank (params = {}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.choose-main-bank-account'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  static async changePassword (params = {}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.change-password'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
